export const DRAWER_SIDES = {
  LEFT: "left",
  RIGHT: "right",
};

export const DEFAULT_DRAWER_STYLES = {
  widthPx: 140,
};
